// extracted by mini-css-extract-plugin
export var active = "_cb-c";
export var compactArrow = "_cb-5";
export var container = "_cb-0";
export var dot = "_cb-b";
export var dotContainer = "_cb-a";
export var hoverArrowButton = "_cb-7";
export var hoverArrowContainer = "_cb-6";
export var leftHoverArrowContainer = "_cb-8 _cb-6";
export var rightHoverArrowContainer = "_cb-9 _cb-6";
export var slide = "_cb-4";
export var sliderContainer = "_cb-1";
export var sliderContainerVisibleOverflow = "_cb-2";
export var sliderOverflow = "_cb-3";
export var vignetteBoth = "_cb-f";
export var vignetteLeft = "_cb-e";
export var vignetteRight = "_cb-d";